import { useEffect } from "react"
import dayjs from "./utils/dayjs"
import "./App.css"
import "./components/Navbar/Navbar.css"
import {
  useBackendError,
  useForcedTurnOff,
  useLoading,
  useSnackbar,
} from "./app/hooks"
import { store } from "./app/store"
import { setValueLists } from "./app/slices/valueListSlice"
import { Loader, SnackbarItemComponent } from "./Shared"
import * as valueList from "./functions/setCodeTableValues"
import BeErrorComponent from "./components/BeErrorComponent/BeErrorComponent"
import { RouterProvider } from "react-router"
import router from "./router"

const App = () => {
  const loader = useLoading()
  const isLoaderOff = useForcedTurnOff()
  const snackbar = useSnackbar()
  const beError = useBackendError()

  useEffect(() => {
    const localValueLists = JSON.parse(
      localStorage.getItem("VTM-VALUELISTS") || "{}",
    )
    if (
      localValueLists?.saveDate &&
      dayjs.utc(localValueLists.saveDate).startOf("day").format() ===
        dayjs.utc().startOf("day").format()
    ) {
      store.dispatch(setValueLists(localValueLists))
    } else {
      valueList.setCodeTableValues()
    }
  }, [])

  return (
    <>
      <RouterProvider router={router} />
      <div>
        {loader && !snackbar && !isLoaderOff && <Loader></Loader>}
        {snackbar && <SnackbarItemComponent></SnackbarItemComponent>}
      </div>
      {beError && <BeErrorComponent />}
    </>
  )
}

export default App
